import { useNavigate } from 'react-router';
import { Button, Center, Paper, PasswordInput, Stack, Text, Title } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api.ts';
import { avisarOk, mostrarError } from '../formato.ts';
import { CLAVE_YO, usePerfil } from '../sesion.ts';

/** Formulario de cambio de contraseña; se usa solo (primer ingreso) y dentro de Mi cuenta. */
export function FormularioPassword({ alTerminar }: { alTerminar?: () => void }) {
  const qc = useQueryClient();
  const form = useForm({
    initialValues: { actual: '', nueva: '', repetir: '' },
    validate: { repetir: (v, valores) => (v !== valores.nueva ? 'No coincide con la nueva' : null) },
  });

  async function guardar(v: typeof form.values) {
    try {
      await api.post('/api/auth/password', { actual: v.actual, nueva: v.nueva });
      avisarOk('Contraseña actualizada. Se cerraron tus otras sesiones.');
      form.reset();
      await qc.invalidateQueries({ queryKey: CLAVE_YO });
      alTerminar?.();
    } catch (e) {
      mostrarError(e, form);
    }
  }

  return (
    <form onSubmit={form.onSubmit(guardar)}>
      <Stack>
        <PasswordInput label="Contraseña actual" autoComplete="current-password" required {...form.getInputProps('actual')} />
        <PasswordInput label="Contraseña nueva" description="Mínimo 12 caracteres, con letras y números" autoComplete="new-password" required {...form.getInputProps('nueva')} />
        <PasswordInput label="Repetir la nueva" autoComplete="new-password" required {...form.getInputProps('repetir')} />
        <Button type="submit" loading={form.submitting}>Cambiar contraseña</Button>
      </Stack>
    </form>
  );
}

export function CambiarPassword() {
  const navegar = useNavigate();
  const { data: perfil } = usePerfil();
  return (
    <Center mih="100vh" p="md">
      <Paper withBorder shadow="sm" p="xl" w={420} maw="100%">
        <Stack>
          <Title order={3}>Elegí tu contraseña</Title>
          <Text size="sm" c="dimmed">
            {perfil?.nombre}, entraste con una contraseña temporal. Antes de seguir, elegí una propia.
          </Text>
          <FormularioPassword alTerminar={() => navegar('/', { replace: true })} />
        </Stack>
      </Paper>
    </Center>
  );
}
